'use strict'

import React from 'react'

require('styles//Bg.less')

var classNames = require('classnames')

var bg1 = require('../images/bg_cast.jpg')
var bg1Style = {
  backgroundImage:'url(' + bg1 + ')'
}
var bg2 = require('../images/bg_theater.jpg')
var bg2Style = {
  backgroundImage:'url(' + bg2 + ')'
}

class BgComponent extends React.Component {
  constructor(props)
  {
    super(props);
    this.state = {
      bg:1,
      bg1:true,
      bg2:false
    };
  }
  componentDidMount()
  {
    window.addEventListener('scroll', this.scroll.bind(this))
  }
  componentWillUnmount()
  {
    window.removeEventListener('scroll', this.scroll.bind(this))
  }
  scroll(e)
  {
    var sh;
    if (e.srcElement)
    {
      sh = e.srcElement.body.scrollTop
    }
    else
    {
      sh = e.target.body.scrollTop
    }
    var cast = document.getElementById('cast')
    var castHeight = cast.getBoundingClientRect().top + window.pageYOffset - window.innerHeight
    var theater = document.getElementById('theater')
    var theaterHeight = theater.getBoundingClientRect().top + window.pageYOffset - window.innerHeight
    if (sh > theaterHeight - 100)
    {
      if (this.state.bg != 2)
      {
        this.setState({
          bg:2,
          bg1:false,
          bg2:true
        })
      }
    }
    else if (sh > castHeight - 100)
    {
      if (this.state.bg != 1)
      {
        this.setState({
          bg:1,
          bg1:true,
          bg2:false
        })
      }
    }
  }
  render()
  {
    var cl = classNames({
      bg1:this.state.bg1,
      bg2:this.state.bg2
    })
    return (
      <div id='bg' className={cl} style={ this.state.bg == 1 ? bg1Style : bg2Style } />
    )
  }
}

BgComponent.displayName = 'BgComponent'

// Uncomment properties you need
// BgComponent.propTypes = {}
// BgComponent.defaultProps = {}

export default BgComponent



/** WEBPACK FOOTER **
 ** ./src/components/BgComponent.js
 **/